import "core-js/modules/es.function.name.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-742835d5"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "IntroAvatarViewer"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "max-width": "100vw",
      "position": "absolute",
      "top": "0px",
      "left": "0px"
    }
  }, [/*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100vw",
    height: "auto",
    viewBox: "0 0 413 68",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M264.485 27.6455C354.892 20.6062 389.665 32.6292 413 44.5L413 -0.00012207L0 -0.000120029L0 65C95.007 77.9608 151.477 36.4445 264.485 27.6455Z",
    fill: "white",
    "fill-opacity": "0.08"
  })])], -1);
});
var _hoisted_3 = {
  style: {
    "color": "#FFF",
    "text-align": "center",
    "text-shadow": "7px -2px 4px rgba(0, 0, 0, 0.25)",
    "font-family": "'Nunito Sans'",
    "font-size": "32px",
    "font-style": "normal",
    "font-weight": "700",
    "margin-top": "36px",
    "line-height": "27px",
    "z-index": "1000"
  }
};
var _hoisted_4 = {
  key: 1,
  "class": "liveHolder"
};
var _hoisted_5 = /*#__PURE__*/_createStaticVNode("<span style=\"color:white;\" data-v-742835d5><span class=\"green\" data-v-742835d5><span class=\"icon\" data-v-742835d5><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" data-v-742835d5><path d=\"M7.90283 8.99557C7.90283 9.23119 7.99643 9.45716 8.16304 9.62376C8.32964 9.79037 8.55561 9.88397 8.79123 9.88397C9.02684 9.88397 9.25281 9.79037 9.41942 9.62376C9.58602 9.45716 9.67962 9.23119 9.67962 8.99557C9.67962 8.75996 9.58602 8.53399 9.41942 8.36738C9.25281 8.20078 9.02684 8.10718 8.79123 8.10718C8.55561 8.10718 8.32964 8.20078 8.16304 8.36738C7.99643 8.53399 7.90283 8.75996 7.90283 8.99557Z\" stroke=\"#00FF0A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-742835d5></path><path d=\"M12.256 16.2004V16.2093M15.0455 13.9795V13.9883M16.5825 10.7723V10.7812M16.5825 7.21877V7.22765M15.0455 4.01166V4.02054M12.256 1.79067V1.79956M8.79123 1V1.00888M5.32649 1.79067V1.79956M2.53692 4.01166V4.02054M1 7.21877V7.22765M1 10.7723V10.7812M2.53692 13.9795V13.9883M5.32649 16.2004V16.2093M8.79123 16.9911V17M4.34925 8.99556C4.34925 10.1736 4.81724 11.3035 5.65028 12.1365C6.48331 12.9695 7.61314 13.4375 8.79123 13.4375C9.96931 13.4375 11.0991 12.9695 11.9322 12.1365C12.7652 11.3035 13.2332 10.1736 13.2332 8.99556C13.2332 7.81747 12.7652 6.68764 11.9322 5.85461C11.0991 5.02157 9.96931 4.55358 8.79123 4.55358C7.61314 4.55358 6.48331 5.02157 5.65028 5.85461C4.81724 6.68764 4.34925 7.81747 4.34925 8.99556Z\" stroke=\"#00FF0A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-742835d5></path></svg></span><span style=\"margin-left:5px;\" data-v-742835d5><u data-v-742835d5><i data-v-742835d5>Live Video</i></u></span> <span style=\"color:white;\" data-v-742835d5>Available</span></span></span>", 1);
var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = {
  "class": "avatar__holderthing"
};
var _hoisted_8 = {
  "class": "feature_item-container"
};
var _hoisted_9 = {
  "class": "feature_item"
};
var _hoisted_10 = {
  "class": "feature_item"
};
var _hoisted_11 = {
  "class": "feature_item"
};
var _hoisted_12 = {
  "class": "feature_item"
};
var _hoisted_13 = {
  "class": "feature_item"
};
var _hoisted_14 = {
  "class": "feature_item"
};
var _hoisted_15 = {
  "class": "feature_item"
};
var _hoisted_16 = {
  key: 0,
  "class": "feature_item"
};
var _hoisted_17 = {
  "class": "next"
};
var _hoisted_18 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "flex-direction": "row",
    "margin-top": "20px",
    "width": "100%",
    "max-width": "100%"
  }
};
var _hoisted_19 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"backbutton\" data-v-742835d5><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"31\" viewBox=\"0 0 23 31\" fill=\"none\" data-v-742835d5><g filter=\"url(#filter0_d_30_369)\" data-v-742835d5><path d=\"M12.1557 4.04764L1.222 13.3038C1.04586 13.453 0.904464 13.6381 0.807527 13.8463C0.71059 14.0546 0.6604 14.2811 0.6604 14.5103C0.6604 14.7395 0.71059 14.966 0.807527 15.1743C0.904464 15.3825 1.04586 15.5676 1.222 15.7168L12.1557 24.973C13.1993 25.8563 14.8113 25.1239 14.8113 23.7664V5.25151C14.8113 3.89402 13.1993 3.16163 12.1557 4.04764Z\" fill=\"white\" data-v-742835d5></path></g><defs data-v-742835d5><filter id=\"filter0_d_30_369\" x=\"0.6604\" y=\"0.66037\" width=\"22.1509\" height=\"29.6981\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-742835d5><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-742835d5></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-742835d5></feColorMatrix><feOffset dx=\"4\" dy=\"1\" data-v-742835d5></feOffset><feGaussianBlur stdDeviation=\"2\" data-v-742835d5></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-742835d5></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-742835d5></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_30_369\" data-v-742835d5></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_30_369\" result=\"shape\" data-v-742835d5></feBlend></filter></defs></svg></div><div class=\"button__label\" data-v-742835d5>Back</div>", 2);
var _hoisted_22 = [_hoisted_20];
var _hoisted_23 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_24 = {
  "class": "button__label"
};
var _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"checkmark\" data-v-742835d5><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"36\" viewBox=\"0 0 42 36\" fill=\"none\" data-v-742835d5><g filter=\"url(#filter0_d_21_729)\" data-v-742835d5><path d=\"M13.2922 28.0075L4.40064 18.962C3.86645 18.4186 3.86645 17.5375 4.40064 16.994L6.33513 15.026C6.86932 14.4825 7.73549 14.4825 8.26968 15.026L14.2594 21.1193L27.0888 8.06794C27.623 7.52451 28.4892 7.52451 29.0234 8.06794L30.9578 10.036C31.492 10.5794 31.492 11.4605 30.9578 12.004L15.2267 28.0075C14.6925 28.551 13.8263 28.551 13.2922 28.0075Z\" fill=\"white\" data-v-742835d5></path></g><defs data-v-742835d5><filter id=\"filter0_d_21_729\" x=\"0\" y=\"0.66037\" width=\"41.3585\" height=\"34.7547\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-742835d5><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-742835d5></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-742835d5></feColorMatrix><feOffset dx=\"3\" data-v-742835d5></feOffset><feGaussianBlur stdDeviation=\"3.5\" data-v-742835d5></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-742835d5></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-742835d5></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_21_729\" data-v-742835d5></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_21_729\" result=\"shape\" data-v-742835d5></feBlend></filter></defs></svg></div>", 1);
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#000",
      "text-align": "center",
      "text-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)",
      "font-family": "'Nunito Sans'",
      "font-size": "15px",
      "font-style": "normal",
      "font-weight": "300",
      "margin-top": "8px",
      "line-height": "normal"
    }
  }, "You can always choose another AIVitar Selection Later!", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ShowXrated = _resolveComponent("ShowXrated");
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.$store.state.appType !== 'Web' && _ctx.$store.state.appExpectations.romantic && _ctx.$store.state.selectedGalleryAvatar.isPro === false ? (_openBlock(), _createBlock(_component_ShowXrated, {
    key: 0,
    style: {
      "border-radius": "7px",
      "background": "rgb(255, 255, 255)",
      "box-shadow": "rgba(0, 0, 0, 0.28) 6px 7px 6px 0px",
      "border": "5px solid rgba(255, 255, 255, 0.27)",
      "position": "absolute",
      "bottom": "12px",
      "min-height": "89px",
      "top": "125px",
      "max-height": "98px"
    }
  })) : _createCommentVNode("", true), _hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$store.state.selectedGalleryAvatar.name), 1), _ctx.$store.state.selectedGalleryAvatar.fullyAnimated ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    style: _normalizeStyle($options.avatarStyle),
    "class": "avatar__image"
  }, null, 4)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  }), _createTextVNode(" Can have VERBAL conversations ")]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  }), _createTextVNode(" Can CHAT with you ")]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  }), _createTextVNode(" Has ability for long-term memories (can turn off) ")]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  }), _createTextVNode(" Has contextual understanding (can turn off) ")]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  }), _createTextVNode(" Can perform advanced tasks* ")]), _createElementVNode("div", _hoisted_14, [_ctx.$store.state.selectedGalleryAvatar.fullyAnimated ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  })) : _createCommentVNode("", true), !_ctx.$store.state.selectedGalleryAvatar.fullyAnimated ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    icon: "fa-times",
    "class": "fas fa-check feature_item-icon--not"
  })) : _createCommentVNode("", true), _createTextVNode(" Fully Animated ")]), _createElementVNode("div", _hoisted_15, [_ctx.$store.state.selectedGalleryAvatar.animated ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  })) : _createCommentVNode("", true), !_ctx.$store.state.selectedGalleryAvatar.animated ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    icon: "fa-times",
    "class": "fas fa-check feature_item-icon--not"
  })) : _createCommentVNode("", true), _createTextVNode(" Animated Photo ")]), _ctx.$store.state.appExpectations.romantic ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_ctx.$store.state.selectedGalleryAvatar.XXX ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: "fa-check",
    "class": "fas fa-check feature_item-icon"
  })) : _createCommentVNode("", true), !_ctx.$store.state.selectedGalleryAvatar.XXX ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
    key: 1,
    icon: "fa-times",
    "class": "fas fa-check feature_item-icon--not"
  })) : _createCommentVNode("", true), _createTextVNode(" Can send you nude photos ")])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
    "class": "button",
    style: {
      "padding-top": "0px"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.backButton();
    })
  }, _hoisted_22)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("button", {
    "class": "button button--secondary",
    style: {
      "padding-top": "0px"
    },
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.useAvatar();
    })
  }, [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$store.state.singleIntroSave ? 'Confirm New AIVitar' : 'Select & Customize'), 1), _hoisted_25])])]), _hoisted_26])]);
}